import React from 'react';
import { Box, costFormater, Text } from '@common-fe/common-fe';

import { useGetDecimal } from '../hooks';

import { AmountDecimal, AmountValue } from './EmployerAmount.styles';

interface AmountProps {
  value: number;
  disabled: boolean;
  testIdPrefix: string;
}

const Amount: React.FC<AmountProps> = ({ value, disabled, testIdPrefix }) => {
  const { value: cuttedValue, decimal } = useGetDecimal(value);
  // Font size is driven by the length of the formatted whole-dollar string
  // (number-based breakpoints), not the viewport or container width.
  const formatted = costFormater(cuttedValue);

  return (
    <Text weight={700} color={disabled ? 'textDisabled' : 'textBody'} data-testid={`${testIdPrefix}-value`}>
      <AmountValue $formatted={formatted}>
        {formatted}
        <AmountDecimal $formatted={formatted}>{decimal || '00'}</AmountDecimal>
      </AmountValue>
    </Text>
  );
};

interface Props {
  investmentsValue: number;
  cashValue: number;
}
const EmployerSpendsTitle: React.FC<Props> = ({ cashValue, investmentsValue }) => {
  return (
    <Box direction="column" data-testid="employer-spends-title">
      <Box
        direction="column"
        margin={{ bottom: 'spacing12' }}
        data-testid="employer-spends-title-cash-section"
      >
        <Amount value={cashValue} disabled={!cashValue} testIdPrefix="employer-spends-title-cash" />
        <Box direction="row" align="center">
          <Text
            color={!cashValue ? 'textDisabled' : 'textBody'}
            data-testid="employer-spends-title-cash-label"
          >
            Cash balance
          </Text>
          <Box
            width="12px"
            height="4px"
            round="smallRound"
            background="iconAccent"
            margin={{ left: 'spacing4' }}
            style={{ opacity: !cashValue ? 0.5 : 1 }}
            data-testid="employer-spends-title-cash-indicator"
          />
        </Box>
      </Box>
      <Box direction="column" data-testid="employer-spends-title-investments-section">
        <Amount
          value={investmentsValue}
          disabled={!investmentsValue}
          testIdPrefix="employer-spends-title-investments"
        />
        <Box direction="row" align="center">
          <Text
            color={!investmentsValue ? 'textDisabled' : 'textBody'}
            data-testid="employer-spends-title-investments-label"
          >
            Investments balance
          </Text>
          <Box
            width="12px"
            height="4px"
            round="smallRound"
            background="needsHelp"
            margin={{ left: 'spacing4' }}
            style={{ opacity: !investmentsValue ? 0.5 : 1 }}
            data-testid="employer-spends-title-investments-indicator"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default EmployerSpendsTitle;
